import axios, { AxiosRequestConfig } from "axios";
import { ConfigModule } from "@/store/modules/config";
import { UserModule } from "@/store/modules/user.store";
import { GetTokenByRefreshTokenDto } from "./v1/mrfiktiv.api";
import Vue from "vue";

export class Api {
  instance() {
    const client = axios.create({
      baseURL: ConfigModule.mrfiktivBaseUrl,
      timeout: 20000
    });
    // Add a silent refresh token interceptor
    client.interceptors.request.use(async config => await this.addBearerTokenToRequest(config));

    return client;
  }

  /**
   * Add bearer token to request.
   *
   * @param config intercepted AxiosRequestConfig to add bearer token to headers.Authorization
   * @returns AxiosRequestConfig to use in axios.request
   */
  async addBearerTokenToRequest(config: AxiosRequestConfig) {
    // User is not logged in (as in has no access token)
    if (!UserModule.authAccessTokens) {
      return config;
    }

    try {
      await this.tryRefreshExpiredToken();

      if (UserModule.authAccessTokens.accessToken) {
        const token = `Bearer ${UserModule.authAccessTokens.accessToken}`;
        config.headers.Authorization = token;
      }
    } catch (error) {
      //refresh didn't work. Remove user tokens.
      UserModule.forceLogout();

      Vue.$log.error(error);
      throw error;
    }

    return config;
  }

  /**
   * Get token by refresh token using the cached credentials in <see "UserModule"/> .
   */
  async tryRefreshExpiredToken() {
    const expiresAt = UserModule.authAccessTokens.expiresAt;

    if (expiresAt) {
      //check if authAccessToken is invalid
      if (Date.now() > parseInt(expiresAt)) {
        // check if we have the necessary information to refresh a token
        if (!UserModule.user || !UserModule.user.authInfo) {
          throw Error("Unable to refresh token: user.authInfo missing.");
        }

        //token is invalid -> refresh it
        const refresh: GetTokenByRefreshTokenDto = {
          uuidUsername: UserModule.user.authInfo.username,
          refreshToken: UserModule.authAccessTokens.refreshToken
        };
        await UserModule.refresh(refresh);
      }
    }
  }
}
